export const customFormats = {
  "phone-us": /\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{4}$/,
  name: /^[a-zA-Z .-]*$/,
  grpname: /^[a-z0-9A-Z_ .-]*$/,
  nameList: /^[a-zA-Z .,-]*$/,
  mobileNumber: /\d{10}$/,
  //mobileNumber:/^((?!(0))[0-9]{10})$/,
  TAGDesc: /^[A-Z<>-_ ]*$/,
  remarksOrDesc: /^[a-zA-Z.&^%$#@* ()-_ ?]*$/,
  udyogaadharno: /^[A-Z]{2}[0-9]{10}$/,
  uan: /[A-Z]{2}\d{2}[A-F]{1}\d{7}$/,
  gst: /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/,
  pincode: /^([1-9])([0-9]){5}$/,
  dipp: /^[0-9]{5}$/,
  url: /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/,
  cin: /^([L|U]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
  emailid: /^\S+@\S+\.\S+$/,
  din: /\d{8}$/,
  digits: /^[0-9]+$/,
  amount: /^[0-9]{1,7}(\.[0-9]{1,8})?$/,
  tan: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
  arnnumber: /^[A-Z]{2}[0-9]{14}$/,
  aadhar: "^[1-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$",
  pan: /^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$/,
  accontnumber: /^[0-9]*$/,
  ifsc: /^[A-Z]{4}0[A-Z0-9]{6}$/,
  alphanumeric: /^[a-z0-9A-Z]*$/,
  latitude: /^(\+|-)?(?:90(?:(?:\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,6})?))$/,
  longitude: /^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/,
  monthyear: /^[0-9 -/]*$/,
  userdetpassword: /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#]).{8,16})$/,
  userdetloginname: /^[a-z0-9._-]*$/,
  userdetfirstname: /^[a-zA-Z][a-zA-Z. -]*$/,
  userdetlastname: /^[a-zA-Z. -]*$/,
  userdetemailid: /^\S+@\S+\.\S+$/,
  userdetcontactnumber: /^[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-/\s.]?[0-9]{4}$/,

  profilename: /^[a-zA-Z. -]*$/,
  profiledesc: /^[a-zA-Z.&^%$#@*()-_ ?]*$/,
  profilenote: /^[a-zA-Z.&^%$#@*()-? _]*$/,

  companyname: /^[a-zA-Z.&^%$#@* ()-_]*$/,

  bodname: /^[a-zA-Z. -]*$/,
  bodpersondetails: /^\S+@\S+\.\S+$/,

  boolean: 1 ? true : false,
  year: /^\d{4}$/,
  "data-url": /^[a-zA-Z0-9.&^%$#@* ()-_ ?]*$/,
  nonEmptyString: /^\S.+$/,
  passportIndia: /^[A-PQR-WYZ][1-9]\d\s?\d{4}[1-9]$/,
};

export function transformErrors(errors) {
  //console.log('transformErrors: ');
  //console.log(errors);
  return errors.map((error) => {
    if (error.name === "required") {
      error.message = "Mandatory field";
    }
    if (error.params.format === "userdetloginname") {
      error.message =
        "Special characters are not allowed. Allowed characters are [a-z0-9._-].";
    }
    if (
      error.params.format === "userdetfirstname" ||
      error.params.format === "userdetlastname" ||
      error.params.format === "profilename" ||
      error.params.format === "name" ||
      error.params.format === "bodname"
    ) {
      error.message =
        "Special characters are not allowed. Allowed characters are [a-zA-Z. -].";
    }
    if (error.params.format === "nameList") {
      error.message =
        "Special characters are not allowed. Allowed characters are [a-zA-Z., -].";
    }
    if (
      error.params.format === "userdetemailid" ||
      error.params.format === "emailid" ||
      error.params.format === "bodpersondetails"
    ) {
      error.message = "Enter valid e-mail.";
    }
    if (error.params.format === "userdetpassword") {
      error.message =
        "Numeric, Upper case, Lower case, special character must have atleast one, Minimum eight characters and Maximum sixteen characters.";
    }
    if (
      error.params.format === "profiledesc" ||
      error.params.format === "profilenote" ||
      error.params.format === "remarksOrDesc" ||
      error.params.format === "userdetnote"
    ) {
      error.message =
        "Special characters are not allowed. Allowed characters are [a-zA-Z.&^%$#@*()-_ ?].";
    }
    if (error.params.format === "companyname") {
      error.message =
        "Special characters are not allowed. Allowed characters are [a-zA-Z.&^%$#@* ()-_].";
    }
    if (error.params.format === "gst") {
      error.message = "Enter valid GST number, e.g. 33XXXXX1234Z1Z1";
    }
    if (error.params.format === "udyogaadharno") {
      error.message = "Enter valid aadhar number.";
    }
    if (error.params.format === "aadhar") {
      error.message = "Enter valid  12 digit aadhar number. ";
    }
    if (error.params.format === "latitude") {
      error.message = "Enter valid latitude. ";
    }
    if (error.params.format === "longitude") {
      error.message = "Enter valid longitude. ";
    }
    if (error.params.format === "uan") {
      error.message = "Enter valid UAN number. e.g. XX02[A-F]0155342";
    }
    if (error.params.format === "pincode") {
      error.message = "Enter valid pincode number.";
    }
    if (
      error.params.format === "userdetcontactnumber" ||
      error.params.format === "mobileNumber"
    ) {
      error.message = "Enter valid mobile number.";
    }
    if (error.params.format === "cin") {
      error.message = "Enter valid CIN Number. e.g. [L|U]12345XX2020XXX098765";
    }
    if (error.params.format === "din") {
      error.message = "Enter valid DIN Number. e.g. 8 digit Number";
    }
    if (error.params.format === "dipp") {
      error.message = "Enter valid DIPP Number. e.g. 5 digit Number";
    }
    if (error.params.format === "amount") {
      error.message = "Enter valid value.";
    }
    if (error.params.format === "digits") {
      error.message = "Enter valid value digits.";
    }
    if (error.params.format === "url") {
      error.message = "Enter valid URL.";
    }
    if (error.params.format === "tan") {
      error.message = "Enter valid TAN number. e.g. XXXX00000X";
    }
    if (error.params.format === "pan") {
      error.message = "Enter valid PAN number. e.g. XXXXX0000X";
    }
    if (error.params.format === "arnnumber") {
      error.message = "Enter valid ARN Number. e.g. XX00000000000000";
    }
    if (error.name === "accontnumber") {
      error.message = "Enter valid Account number";
    }
    if (error.params.format === "ifsc") {
      error.message = "Enter valid IFSC Code e.g. XXXX0000000";
    }
    if (error.name === "alphanumeric") {
      error.message = "Enter Alpha numeric characters";
    }
    if (error.name === "month") {
      error.message = "Enter mm/yyyy - mm/yyyy";
    }
    if (error.name === "type") {
      error.message = "* Required Fields.";
    }
    if (error.params.format === "year") {
      error.message = "Enter valid Year e.g. 2000";
    }
    if (error.params.format === "nonEmptyString") {
      error.message = "Empty String";
    }
    if (error.params.format === "passportIndia") {
      error.message = "Enter valid Indian Passport Number";
    }
    return error;
  });
}
